export const tagLabelConfig = {
    name: 'TagLabel',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/e336d50f7ddf3c8f6d0beb215d5014a7.png',
    inputs: [
        {
            name: 'text',
            type: 'richText',
            required: true,
        },
        {
            name: 'color',
            type: 'string',
            enum: [
                'peach',
                'gray',
                'white',
                'info',
                'success',
                'warning',
                'error',
                'neutral300',
                'bolt',
                'cream',
                'success500',
            ],
        },
        {
            name: 'size',
            type: 'string',
            enum: ['small', 'medium'],
        },
    ],
};
//# sourceMappingURL=config.js.map